import * as errors from "../errors.js";
import { state } from "../state.js";
/*
    STR$ is used to converting numerical values or variables into a string. When the number is positive or 0, the first char is a space. 
    When it is a negative number, the first char is a minus (-).
    If you call this on the wrong type of variable, like a string, the BASIC-error ?TYPE MISMATCH ERROR in line will be returned.
    Like any numeric function, STR$ works if the expression evaluates to a value +/- 1e+38 or floating numbers with maximal 9 decimal places inside 
    the range +/- 1e+28. If the resulting value is outside these bounds, the BASIC-error ?OVERFLOW ERROR IN line will be returned.
    If the numerical argument is missing, the BASIC-error ?SYNTAX ERROR IN line is viewed. 
*/
export const str = async (args) => {
    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Convert the number to a string.
    return String(args);
};